export default "__VITE_ASSET__DRV3lRH6__"